import React from 'react'
import {useDispatch} from 'react-redux'
import {toggleMyInfoLayer} from "../../actions";

export default function() {

  const dispatch = useDispatch()

  function handleToggleLayer(e) {
    e.preventDefault();
    e.stopPropagation();
    dispatch(toggleMyInfoLayer())
  }

  const user = window.Config.user
  const appInfo = window.appInfo

  return (
    <div id="kakaoHead" role="banner" className="kakao_head gnb_mv">
      <div className={`inner_header ${appInfo.service}`}>
        <h1 className='tistory_logo'>
          <a href={appInfo.topUrl} id="kakaoServiceLogo" className="link_logo">
            <span className="img_common_tistory tit_tistory">
              {appInfo.service === 'tistory'? '티스토리' : '다음블로그'}
            </span>
          </a>
        </h1>
        <div className="info_tistory">
          <div className="profile_tistory">
            <strong className="tit_nickname">{user.name}</strong>
            <a href="#" className="link_profile" onClick={handleToggleLayer}>
              <span className="thumb_profile" style={{backgroundImage:`url('${user.profileImageUrl}')`}}>{user.name}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
